import ajax from '../ajax'
//获取作者
export function getAuthorApi(data) {
    return ajax({
        method:'GET',
        url: 'v2/refer/author',
    })
}
//添加作者
export function addAuthorApi(data) {
    return ajax({
        method:'post',
        url: 'v2/refer/addauthor',
        data
    })
}

//获取上传签名
export function getUploadSignatureApi(data) {
    return ajax({
        method:'post',
        url: 'v2/refer/sign',
        data
    })
}
//开始上传
export function startUploadApi(url,FormData) {
    return ajax({
        method:'post',
        url: url,
        data:FormData
    })
}
//查看上传文件是否重复
export function repeatImgApi(params) {
    return ajax({
        method:'get',
        url: 'v2/refer/exists',
        params
    })
}
//上传完的回调
export function completeUploadApi(params) {
    return ajax({
        method:'get',
        url: 'v2/refer/finish',
        params
    })
}


// WEBPACK FOOTER //
// ./src/apis/uploadApi/index.js